import * as Sentry from '@sentry/astro'
import {
  STOCK_STATUS_CHECKED,
  STOCK_STATUS_CHECKING,
  STOCK_STATUS_FAILED,
} from '@/legacy/constants/inventory'
import { getStorePrefixedCmsFieldKey } from '@/services/locale/plugin'

export default {
  provide() {
    return {
      $inventoryStatus: () => this.inventoryStatus,
      $inventory: () => this.inventory,
    }
  },

  data() {
    return {
      inventoryStatus: STOCK_STATUS_CHECKING,
      inventory: null,
    }
  },

  methods: {
    async fetchProductsInventory(
      { products, productIdKey, returnFailStatus },
      locale,
    ) {
      const resolvedProductIdKey =
        productIdKey || getStorePrefixedCmsFieldKey(locale, 'storeProductId')
      const shopifyProductIds = products.reduce(
        (allProductIds, currentProduct) => {
          if (!currentProduct || !currentProduct[resolvedProductIdKey])
            return allProductIds
          return [
            ...allProductIds,
            `id:${currentProduct[resolvedProductIdKey]}`,
          ]
        },
        [],
      )

      const inventoryFetchedEvent = (status) =>
        new CustomEvent('inventory:fetched', {
          detail: {
            status,
          },
        })

      try {
        const inventoryQueryChunkSize = 100
        const productChunks = Array(
          Math.ceil(shopifyProductIds.length / inventoryQueryChunkSize),
        )
          .fill()
          .map((_, index) => index * inventoryQueryChunkSize)
          .map((begin) =>
            shopifyProductIds.slice(begin, begin + inventoryQueryChunkSize),
          )
        const inventoryQueries = productChunks.map(
          (productIds) =>
            new Promise((resolve, reject) => {
              window.cart.inventory.fetch
                .byProductIds(productIds)
                .then((values) => {
                  if (values) resolve(values)
                  reject(new Error('fail to get inventory level'))
                })
            }),
        )
        const inventories = await Promise.all(inventoryQueries)
        if (!Object.keys(inventories).length)
          throw new Error('fail to get inventory levels')

        // @todo eventually remove this.inventory sets and this files providers. Keeping to keep other pages running for now
        this.inventory = Object.assign({}, this.inventory || {}, ...inventories)
        window.inventory = this.inventory

        this.inventoryStatus = STOCK_STATUS_CHECKED

        window.dispatchEvent(inventoryFetchedEvent(STOCK_STATUS_CHECKED))
      } catch (error) {
        window.dispatchEvent(inventoryFetchedEvent(STOCK_STATUS_FAILED))
        Sentry.captureException(error)
      }
    },
  },
}
